<template>
    <div class="col-md-12 px-0 py-0">
        <div class="my-3">
            <div class="form-inline">
                <div class="form-group">
                    <select
                        class="form-control"
                        placeholder="Seleccione un concurso"
                        v-model="contestId"
                    >
                        <option value="0">Seleccione un concurso</option>
                        <option
                            :value="item.id"
                            v-for="item in contestList"
                            :key="item.id"
                        >
                            {{ item.name }} / v-{{ item.version }}
                        </option>
                    </select>
                </div>
                <button
                    type="button"
                    class="btn btn-primary ml-2"
                    @click="searchProjects()"
                >
                    Seleccionar
                </button>
            </div>
        </div>
        <div v-if="contestUsersEmail.length > 0">
            <form action="" method="post" class="form-horizontal mt-5">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Asunto</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="subject"
                        class="form-control"
                        placeholder="Asunto"
                    />
                    <span
                        v-if="allerrors.subject"
                        :class="['show-error']"
                        >{{ allerrors.subject[0] }}</span
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Mensaje</label
                >
                <div class="col-md-9">
                    <ckeditor
                        :editor="editor"
                        v-model="body"
                        :config="editorConfig"
                    ></ckeditor>
                    <span v-if="allerrors.body" :class="['show-error']">{{
                        allerrors.body[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" @click="send()" class="btn btn-primary">
                    Enviar
                </button>
            </div>
        </form>
        </div>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
    data() {
        return {
            contestId: "0",
            contestList: [],
            contestUsersEmail: [],
            subject: null,
            body: null,
            allerrors: {
                subject: null,
                body: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [ '|',
                            'heading',
                            'bold',
                            'italic',
                            'link',
                            'bulletedList',
                            'numberedList',
                            '|',
                            'outdent',
                            'indent',
                            '|',
                            'undo',
                            'redo'
                        ],
            },
        };
    },
    methods: {
        searchProjects() {
            if (this.contestId > 0) {
                this.getUsersEmail();
            }
        },
        getListContest() {
            let _this = this;
            axios
                .get("/api/contests?paginate=false")
                .then(function (response) {
                    _this.contestList = response.data;
                })
                .catch(function (error) {});
        },
        getUsersEmail(){
            let me = this;
            axios
                .get(
                    "/api/projects/get-emails?contest_id=" +
                        me.contestId
                )
                .then(function (response) {
                    me.contestUsersEmail = response.data.data;
                })
                .catch(function (error) {});
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.subject) {
                me.allerrors.subject = [
                    "El campo Asunto es obligatorio.",
                ];
                valid = false;
            } else if (me.subject.length > 50) {
                me.allerrors.subject = [
                    "El campo Asunto debe tener máximo 50 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.subject = [""];
            }

            if (!me.body) {
                me.allerrors.body = [
                    "El campo Mensaje es obligatorio.",
                ];
                valid = false;
            } else if (me.body.length > 5000) {
                me.allerrors.body = [
                    "El campo Mensaje máximo 5000 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.body = [""];
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                subject: null,
                body: null,
            };
        },
        clearData() {
            let me = this;
            me.contestId= "0";
            me.contestUsersEmail= [];
            me.subject= null;
            me. body= null
        },
        loading() {
            this.$swal({
                text: "Procesando su solicitud, un momento por favor...",
                showConfirmButton: false,
                willOpen: () => {
                    this.$swal.showLoading();
                },
            });
        },
        showAlert(type, title, text) {
            this.$swal({
                title: title,
                text: text,
                icon: type,
                type: type,
                confirmButtonText: "Aceptar",
            });
        },
        closeLoading() {
            this.$swal.hideLoading();
        },
        send() {
            let me = this;
            if (me.validForm()) {
                me.loading();
                axios.post("/api/send-emails", {
                    subject: me.subject,
                    body:me.body,
                    contestUsersEmail:me.contestUsersEmail
                })
                .then(response => {
                    if (response.data.success) {
                        me.showAlert(
                            "success",
                            `Correo Enviado.`,
                            `${response.data.message}`
                        );
                        me.clearError();
                        me.clearData();
                    }
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        me.allerrors = error.response.data.errors;
                    }
                })
                .finally(() => {
                    me.closeLoading();
                });
            }
        },
    },
    mounted() {
        this.getListContest();
    },
};
</script>


